// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"Q_dr","categories__list":"Q_ds"};